<template>
    <div class="logo-box" v-if="list && list.length>0">
        <div class="logo-title">
            <div class="line"></div>
            <div>{{title}}</div>
            <div class="line"></div>
        </div>
        <div :class="[mode==0?'image-single':'image-list']">
            <div v-for="(item, i) in list" :key="i"  class="image-item">
                <a :href="item.link" v-if="item.link" target="_blank">
                    <img v-lazy="item.imageUrl"/>
                </a>
                <img v-else v-lazy="item.imageUrl"/>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name:'Logos',
    props:{
        mode:{
            type: Number,
            default:1
        }, 
        typeCode:{
            type: String,
            default: ''
        },
        title:{
            type: String,
            default:''
        }
    },
    watch:{
        typeCode:{
            handler:function(val, oldValue){
                console.log(val+'typeCode change');
                this.getBannerData();
            },
            deep: true,
            immediate: true
        }
    },
    data(){
        return {
            list:[]
        }
    },
    methods:{
        getBannerData(){
            const self = this;
            this.$http.get("/bicycle/inter/banners?type=" + this.typeCode).then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.list = res.data.data;
                }
            }).catch(function(error){
                console.log(error)
            });
        },
    }
}
</script>

<style scoped>
.logo-box{
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
    text-align: center;
}
.logo-title{
    margin-bottom: 28px;
    font-size: 48px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
}
.image-item{
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;
}
.logo-title div{
    display: inline-block;
}
.line{
    width: 100px;
    height: 2px;
    background: black;
    margin-left: 24px;
    margin-right: 24px;
}
.image-single{

}
.image-list{
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-left: 40px;
    marker-end: 40px;
}
.image-list .image-item{
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    margin:24px 1%;
}
.image-list .image-item img{
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Logos.vue